module.exports = __webpack_public_path__ + "media/3-12.663f3264.wav";